import { render, staticRenderFns } from "./SelectRegionModal.vue?vue&type=template&id=bf316a8e&scoped=true"
import script from "./SelectRegionModal.vue?vue&type=script&lang=js"
export * from "./SelectRegionModal.vue?vue&type=script&lang=js"
import style0 from "./SelectRegionModal.vue?vue&type=style&index=0&id=bf316a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf316a8e",
  null
  
)

export default component.exports